import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const SITE_URL = process.env.REACT_APP_SITE_URL || window.location.origin;

export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.response?.status === 429 ? "Previše zahtjeva. Pokušajte kasnije." : "Došlo je do greške. Pokušajte ponovo.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x.field ? `${x.field}: ${x.msg}` : x.msg)).join(" · ");
  return String(d);
}

export function imgSrc(url) {
  if (!url) return "";
  return url.startsWith("/api/") ? `${BACKEND}${url}` : url;
}

const DAYS = ["nedjelja", "ponedjeljak", "utorak", "srijeda", "četvrtak", "petak", "subota"];
const TZ = "Europe/Berlin";
const partsFmt = new Intl.DateTimeFormat("en-GB", { timeZone: TZ, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", weekday: "short", hourCycle: "h23" });
const WD = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
const berlin = (s) => Object.fromEntries(partsFmt.formatToParts(new Date(s)).map((p) => [p.type, p.value]));
// All public dates: DD.MM.YYYY, 24h HH:mm, Europe/Berlin
export const fmtDate = (s) => {
  if (!s) return "";
  const p = berlin(s);
  return `${p.day}.${p.month}.${p.year}`;
};
export const fmtTime = (s) => {
  const p = berlin(s);
  return `${p.hour}:${p.minute}`;
};
export const fmtDateTime = (s) => (s ? `${fmtDate(s)} u ${fmtTime(s)} h` : "");
export const fmtToday = () => {
  const day = DAYS[WD[berlin(Date.now()).weekday]];
  return `${day[0].toUpperCase()}${day.slice(1)}, ${fmtDate(Date.now())}`;
};
export const isToday = (s) => fmtDate(s) === fmtDate(Date.now());
export const fmtRelative = (s) => {
  if (!s) return "";
  const mins = Math.round((Date.now() - new Date(s).getTime()) / 60000);
  if (mins < 1) return "upravo";
  if (mins < 60) return `prije ${mins} min`;
  if (mins < 24 * 60) return `prije ${Math.floor(mins / 60)} h`;
  return fmtDate(s);
};

export const articlePath = (a) => `/${a.category?.slug || "vijesti"}/${a.slug}`;
